export const LECTURE_LOGGING_API = '/api/membership/lecture'
export const SECURE_LECTURE_LOGGING_API = '/api/membership/secure/global/lecture'
export const SESSION_LOGGING_API = '/api/membership/lecture/session'

export const TrackingApi = {
  InitLecture: SECURE_LECTURE_LOGGING_API,
  UpdateLecture: SECURE_LECTURE_LOGGING_API,
  InitQuiz: '/api/membership/quiz',
  UpdateQuiz: '/api/membership/quiz/session',
} as const
